import * as ng from 'angular';

ng.module('e360')
   .factory('getTimezoneService', getTimezoneServiceFactory);

export interface GetTimezoneService {
   (latLng:number[]):ng.IPromise<GoogleTimezone>
}

interface GoogleTimezone {
   dstOffset:number;
   rawOffset:number;
   status:string;
   timeZoneId:string;
   timeZoneName:string;
}

getTimezoneServiceFactory.$inject = ['$q', '$http', 'session'];
export function getTimezoneServiceFactory($q:ng.IQService, $http:ng.IHttpService, session):GetTimezoneService {
   return getTimezone;

   function getTimezone(latLng:number[]) {
      let unixTimestamp = new Date().getTime()/1000;
      let url = `https://maps.googleapis.com/maps/api/timezone/json?location=${latLng.join(',')}&timestamp=${unixTimestamp}&key=${session.googleApiKey()}`;

      return $http.get<GoogleTimezone>(url).then((result) => {
         return result.data;
      });
   }
}
